import { Constants } from "./constants";
export class Logger {

	public info(msg: any) {
		console.info(LogMessage.createLogMessage(msg))
				//SEND TO LOGGING-Service
		console.info(msg);
	}
	public debug(msg: any) {
		console.debug(JSON.stringify(LogMessage.createLogMessage(msg)))
	}
	public error(msg: any) {
		console.error(LogMessage.createLogMessage(msg));
		//SEND TO LOGGING-Service
		console.info(msg);
	}
}

class LogMessage {
	public jsonMsg: string;
	constructor(
		private requestId: string,
		private sessionId: string,
		msg: any) {
		this.jsonMsg = JSON.stringify(msg);
	}

	public static createLogMessage(msg: any): LogMessage {
		let requestId: string  = localStorage.getItem(Constants.REQUEST_ID)
		let sessionId: string  = localStorage.getItem(Constants.SESSION_ID)
		let logMsg: LogMessage = new LogMessage(requestId, sessionId, msg);
		return logMsg;
	}
}



// WEBPACK FOOTER //
// ./src/app/services/logger.service.ts